import { CampaignDetails } from "modules/Types";

export const CAMPAIGN_LABEL_NAME_MAPPINGS: Record<string, string> = {
    'releases': "Grow your releases",
    'fanbase': 'Grow your fanbase',
    'traffic': 'Drive traffic'
}

export const OrderCampaignsByEndDate = (campaigns: CampaignDetails[], order?: 'ASC' | 'DESC') => {
    const orderValue = order === 'ASC' ? 1 : -1;
    return campaigns.sort((a, b) => {
        if (a.campaign_metadata.endDate < b.campaign_metadata.endDate) {
            return -1 * orderValue;
        }
        if (a.campaign_metadata.endDate > b.campaign_metadata.endDate) {
            return 1 * orderValue;
        }
        return 0;
    })
}